const prefix = '/termination';

export const routes = {
  INDEX: prefix,
};
